module.exports = __webpack_public_path__ + "img/suzuki-ertiga-xl7.ba769fe6.jpg";